export default __webpack_public_path__ + "d3a90797dc19f00aacde66f0dd2b5508.png";